// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__QRSVa","logo_image":"Logo_logo_image__2r648"};